// This variable also exists in NCBackend, and we use it in the algo - so if we ever change it we need to change it in both places
export const PREGNANCY_DAYS = 266;
export const MAX_PREGNANCY_DAYS = PREGNANCY_DAYS + 20;
export var PregnancyState = /*#__PURE__*/function (PregnancyState) {
  PregnancyState[PregnancyState["EARLY"] = 1] = "EARLY";
  PregnancyState[PregnancyState["MID"] = 2] = "MID";
  PregnancyState[PregnancyState["FULL_TERM"] = 3] = "FULL_TERM";
  return PregnancyState;
}(PregnancyState || {});
export var PregnancyEndReason = /*#__PURE__*/function (PregnancyEndReason) {
  PregnancyEndReason[PregnancyEndReason["MISCARRIAGE"] = 1] = "MISCARRIAGE";
  PregnancyEndReason[PregnancyEndReason["MEDICAL_TERMINATION"] = 2] = "MEDICAL_TERMINATION";
  PregnancyEndReason[PregnancyEndReason["ECTOPIC_PREGNANCY"] = 3] = "ECTOPIC_PREGNANCY";
  PregnancyEndReason[PregnancyEndReason["MOLAR_PREGNANCY"] = 4] = "MOLAR_PREGNANCY";
  PregnancyEndReason[PregnancyEndReason["BLIGHTED_OVUM"] = 5] = "BLIGHTED_OVUM";
  PregnancyEndReason[PregnancyEndReason["TERMINATION"] = 6] = "TERMINATION";
  PregnancyEndReason[PregnancyEndReason["BIRTH"] = 7] = "BIRTH";
  return PregnancyEndReason;
}(PregnancyEndReason || {});
export var PregnancyEndSymptom = /*#__PURE__*/function (PregnancyEndSymptom) {
  PregnancyEndSymptom[PregnancyEndSymptom["BLEEDING"] = 1] = "BLEEDING";
  PregnancyEndSymptom[PregnancyEndSymptom["SPOTTING"] = 2] = "SPOTTING";
  PregnancyEndSymptom[PregnancyEndSymptom["PAIN"] = 3] = "PAIN";
  PregnancyEndSymptom[PregnancyEndSymptom["NOT_FEELING_PREGNANT"] = 4] = "NOT_FEELING_PREGNANT";
  PregnancyEndSymptom[PregnancyEndSymptom["NO_SYMPTOMS"] = 5] = "NO_SYMPTOMS";
  PregnancyEndSymptom[PregnancyEndSymptom["OTHER"] = 6] = "OTHER";
  return PregnancyEndSymptom;
}(PregnancyEndSymptom || {});
export var ReceivedMedicalCare = /*#__PURE__*/function (ReceivedMedicalCare) {
  ReceivedMedicalCare[ReceivedMedicalCare["YES"] = 1] = "YES";
  ReceivedMedicalCare[ReceivedMedicalCare["NO"] = 2] = "NO";
  return ReceivedMedicalCare;
}(ReceivedMedicalCare || {});
export var PregnancyEndCareType = /*#__PURE__*/function (PregnancyEndCareType) {
  PregnancyEndCareType[PregnancyEndCareType["CONSULTATION"] = 1] = "CONSULTATION";
  PregnancyEndCareType[PregnancyEndCareType["MEDICATION"] = 2] = "MEDICATION";
  PregnancyEndCareType[PregnancyEndCareType["MEDICAL_DELIVERY"] = 3] = "MEDICAL_DELIVERY";
  PregnancyEndCareType[PregnancyEndCareType["SURGERY"] = 4] = "SURGERY";
  PregnancyEndCareType[PregnancyEndCareType["OTHER"] = 5] = "OTHER";
  return PregnancyEndCareType;
}(PregnancyEndCareType || {});
export var BirthDeliveryMethod = /*#__PURE__*/function (BirthDeliveryMethod) {
  BirthDeliveryMethod[BirthDeliveryMethod["VAGINAL"] = 1] = "VAGINAL";
  BirthDeliveryMethod[BirthDeliveryMethod["PLANNED_C_SECTION"] = 2] = "PLANNED_C_SECTION";
  BirthDeliveryMethod[BirthDeliveryMethod["EMERGENCY_C_SECTION"] = 3] = "EMERGENCY_C_SECTION";
  BirthDeliveryMethod[BirthDeliveryMethod["FORCEPS_ASSISTED"] = 4] = "FORCEPS_ASSISTED";
  BirthDeliveryMethod[BirthDeliveryMethod["VBAC"] = 5] = "VBAC";
  BirthDeliveryMethod[BirthDeliveryMethod["VACUUM_ASSISTED"] = 6] = "VACUUM_ASSISTED";
  BirthDeliveryMethod[BirthDeliveryMethod["OTHER"] = 7] = "OTHER";
  return BirthDeliveryMethod;
}(BirthDeliveryMethod || {});
export var BirthComplication = /*#__PURE__*/function (BirthComplication) {
  BirthComplication[BirthComplication["NONE"] = 1] = "NONE";
  BirthComplication[BirthComplication["YES_ME"] = 2] = "YES_ME";
  BirthComplication[BirthComplication["YES_BABY"] = 3] = "YES_BABY";
  return BirthComplication;
}(BirthComplication || {});
export var FeedingMethod = /*#__PURE__*/function (FeedingMethod) {
  FeedingMethod[FeedingMethod["BREASTFEEDING_ON_DEMAND"] = 1] = "BREASTFEEDING_ON_DEMAND";
  FeedingMethod[FeedingMethod["BREASTFEEDING_ON_SCHEDULE"] = 2] = "BREASTFEEDING_ON_SCHEDULE";
  FeedingMethod[FeedingMethod["PUMPING"] = 3] = "PUMPING";
  FeedingMethod[FeedingMethod["FORMULA"] = 4] = "FORMULA";
  FeedingMethod[FeedingMethod["SOLIDS"] = 5] = "SOLIDS";
  return FeedingMethod;
}(FeedingMethod || {});
export const EARLY_PREG_END_KEYS = new Set(['symptoms', 'receivedMedicalCare', 'receivedCareType', 'medicationReceivedDate', 'medicalDeliveryDate', 'surgeryDate', 'notes']);
export const FULL_TERM_PREG_END_KEYS = new Set(['induction', 'numberOfBabies', 'deliveryMethod', 'deliveryMethodOther', 'birthComplications', 'physicalScore', 'mentalScore', 'feedingMethods', 'bcAfterBirth', 'bcAfterBirthOther']);
export const PREGNANCY_STATE_MIN_LENGTH = {
  [PregnancyState.EARLY]: 0,
  [PregnancyState.MID]: 126,
  // 18 weeks
  [PregnancyState.FULL_TERM]: 182 // 26 weeks
};